import React from "react";
import { motion } from "framer-motion";

const MembershipLevels = () => {
  const levels = [
    {
      emoji: "🟤",
      name: "Indie Music Jumpstart",
      tier: "Bronze",
      tagline: "For absolute beginners exploring original music.",
      features: [
        "Melody & songwriting basics",
        "Music clarity & direction",
        "Entry into the creator mindset"
      ]
    },
    {
      emoji: "⚪",
      name: "Foundational",
      tier: "Silver",
      tagline: "For creators serious about composing their first song.",
      features: [
        "Complete melody composing system",
        "Basic production understanding",
        "Guided song projects"
      ],
      highlighted: true
    },
    {
      emoji: "🟡",
      name: "Mastery",
      tier: "Gold",
      tagline: "For artists ready to produce, launch & earn from music.",
      features: [
        "Advanced composition & production",
        "Vocal & genre mastery",
        "Song launch & monetization roadmap"
      ]
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Choose Your Path
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {levels.map((level, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className={`p-8 rounded-xl shadow-lg transition-all ${
                level.highlighted 
                  ? 'bg-gradient-to-br from-purple-100 to-blue-100 border-2 border-purple-600 transform scale-105' 
                  : 'bg-gray-50'
              }`}
            >
              <div className="text-center mb-6">
                <div className="text-6xl mb-3">{level.emoji}</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {level.name}
                </h3>
                <p className="text-purple-600 font-semibold text-lg">({level.tier})</p>
              </div>
              
              <p className="text-gray-700 italic mb-6 text-center">
                {level.tagline}
              </p>
              
              <ul className="space-y-3 mb-6">
                {level.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-gray-700">
                    <span className="text-purple-600 mr-2 font-bold">✔</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <button 
          onClick={() => window.open('https://indiemusiccreators.com/#program', '_blank')}
          className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105 shadow-xl">
            👉 View Full Progam Details →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default MembershipLevels;
